import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { DynamicOptionsComponent } from '../dynamic-options';

@Component({
  template: '',
  standalone: true,
})
export abstract class TagOptionsComponent implements OnInit, DynamicOptionsComponent {
  tagOptionControl: UntypedFormControl = new UntypedFormControl(null, tagsValidator);
  abstract tagOptions$: Observable<string[]>;

  @Input() initialValue: string[];
  selectedValue$ = this.tagOptionControl.valueChanges;

  ngOnInit(): void {
    if (Array.isArray(this.initialValue)) {
      this.tagOptionControl.setValue(this.initialValue);
    }
  }

  getSelectedValue(): string {
    return this.tagOptionControl?.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.tagOptionControl];
  }

  isFormValid(): boolean {
    return this.tagOptionControl.valid;
  }
}

function tagsValidator(control: AbstractControl): { [key: string]: any } {
  return Array.isArray(control.value) && control.value.length > 0 ? null : { error: false };
}
